import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

import * as actions from '../store/modules/auth/actions';
import DashboardEstamparia from './empresa/estamparia/dashboard/dashboardEstamparia';

export default function Home() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user) || {};

  useEffect(() => {
    const newTitle = '';
    dispatch(actions.titleHeaderChange({ newTitle }));
  }, [dispatch]);

  // Empresas do ramo de estamparia: dashboard com orçamentos, pedidos e produção
  if (user.tipoUsuario === 'EMPRESA' && user.modeloNegocio === 'ESTAMPARIA') {
    return <DashboardEstamparia />;
  }

  return (
    <div className="home-dashboard">
      <section className="welcome-card">
        <div>
          <span className="section-eyebrow">Visão geral</span>
          <h1>Olá{user.nome ? `, ${user.nome}` : ''}!</h1>
          <p>Bem-vindo ao seu ambiente de gestão. Use o menu acima para acessar os módulos do sistema.</p>
        </div>
        <div className="welcome-icon"><i className="pi pi-chart-line" /></div>
      </section>
      <section className="home-grid">
        <article className="quick-card"><i className="pi pi-search" /><div><h2>Consultas</h2><p>Encontre cadastros e movimentações com rapidez.</p></div></article>
        <article className="quick-card"><i className="pi pi-file" /><div><h2>Documentos</h2><p>Acompanhe documentos fiscais e operações.</p></div></article>
        <article className="quick-card"><i className="pi pi-chart-bar" /><div><h2>Relatórios</h2><p>Transforme dados em decisões mais seguras.</p></div></article>
      </section>
    </div>
  );
}
